import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SvgColor } from 'src/app/constants/icons';
import { InPageNavItem } from 'src/app/models/in-page-nav';

@Component({
    selector: 'mwp-in-page-nav',
    templateUrl: 'in-page-nav.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})

export class InPageNavComponent implements OnInit {
    @Input() navItems: InPageNavItem[];

    public svgColor = SvgColor;

    constructor() { }

    ngOnInit() { }
}